/* eslint-disable */
import { EVENTS } from '@bs/constants';

/**
 * Interactive hardcoded hub for the Our Solutions block.
 */
export default class OurSolutionsTabs {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    const root = this.element.querySelector('.wrap');
    if (!root) return;

    var GEO = {
      CW: 812,
      CH: 477,
      Ox: 405.8,
      Oy: 241.8,
      ROT: {
        rest: 0.0,
        policy: 90.0,
        comms: -30.0,
        data: -150.0,
        'policy-comms': 30.0,
        'comms-data': -90.0,
        'data-policy': -210.0
      },
      TT: {
        rest: { policy: [0.0, 0.0], comms: [0.0, 0.0], data: [0.0, 0.0] },
        policy: {
          policy: [170.0, 251.6],
          comms: [-467.8, 62.2],
          data: [62.2, -329.8]
        },
        comms: {
          policy: [-286.6, 22.8],
          comms: [22.8, -85.0],
          data: [62.2, 62.2]
        },
        data: {
          policy: [-286.6, 398.8],
          comms: [-467.8, -313.8],
          data: [562.8, -85.0]
        },
        'policy-comms': {
          policy: [85.0, 22.8],
          comms: [-62.2, 62.2],
          data: [-22.8, -85.0]
        },
        'comms-data': {
          policy: [-371.6, 251.6],
          comms: [-62.2, -313.8],
          data: [477.8, 62.2]
        },
        'data-policy': {
          policy: [85.0, 398.8],
          comms: [-552.8, -85.0],
          data: [477.8, -329.8]
        }
      },
      P: 17.0
    };
    var COPY = {
      TABS: {
        theory: {
          label: 'Theory',
          stat: 'How we build lasting public health solutions.',
          copy: 'Data-informed policy, put into practice by strong institutions in dialogue with the public, creates communities where all people can live healthier lives.',
          hub: {
            S: 10,
            STAT: 27,
            LBL: 9,
            H: 210,
            peopleLabel: 'PEOPLE',
            systemsLabel: 'SYSTEMS',
            people: [
              'Reliable data, sound policy and',
              'public support combine to shift',
              'everyday behaviors, so people are safer',
              'and healthier.'
            ],
            stat: ['Improved', 'population health'],
            systems: [
              'We support governments and institutions',
              'to implement, enforce and monitor',
              'policies, turning law into',
              'practice.'
            ],
            ysp: [-86.5, -73.5, -60.5, -47.5],
            yst: [-16.0, 16.0],
            ysy: [59.5, 72.5, 85.5, 98.5],
            ylp: -99.0,
            yly: 47.0
          },
          sats: {
            policy:
              'We provide legal analysis, conduct political mapping and calculate economic and health impacts towards sustainable policies.',
            comms:
              'We help partners build the public support and political will that turn a proposed policy into a lived reality.',
            data: 'We support strengthening the data systems that help decision-makers understand health trends and focus resources.'
          }
        },
        'road-safety': {
          label: 'Road Safety',
          stat: '900,000 lives saved. Millions of injuries averted.',
          copy: 'Road crashes are the leading cause of death for ages 5–29 worldwide. Vital Strategies is an implementing partner of the Bloomberg Philanthropies Initiative for Global Road Safety.',
          hub: {
            S: 10,
            STAT: 23,
            LBL: 9,
            H: 228,
            peopleLabel: 'PEOPLE',
            systemsLabel: 'SYSTEMS',
            people: [
              'Drivers and pedestrians adopt',
              'safer behaviors, like wearing',
              'seatbelts, obeying speed limits and',
              'avoiding drink-driving.'
            ],
            stat: ['900,000 lives saved.', 'Millions of injuries', 'averted.'],
            systems: [
              'Supported governments to enforce',
              'traffic laws, maintain safer roads',
              'and vehicles as a routine part',
              'of daily operations.'
            ],
            ysp: [-95.5, -82.5, -69.5, -56.5],
            yst: [-28.0, 0.0, 28.0],
            ysy: [68.5, 81.5, 94.5, 107.5],
            ylp: -108.0,
            yly: 56.0
          },
          sats: {
            policy:
              'Strengthened legislation, improved enforcement, and advanced safer infrastructure and sustainable urban transport.',
            comms:
              'Shifted risky behaviors like speeding and drink-driving through integrated marketing and policy-adoption campaigns.',
            data: 'Strengthened road safety surveillance to identify the leading risks and guide policy action.'
          }
        },
        'birth-registration': {
          label: 'Birth Registration',
          stat: '17 million Cambodians gained a legal identity.',
          copy: "Roughly 1 in 4 young children worldwide go unregistered at birth, cut off from services and protection. Vital Strategies supported the law behind Cambodia's breakthrough.",
          hub: {
            S: 10,
            STAT: 27,
            LBL: 9,
            H: 244,
            peopleLabel: 'PEOPLE',
            systemsLabel: 'SYSTEMS',
            people: [
              'Families register their',
              'children, gaining access to',
              'healthcare, education and the full',
              'rights of citizenship.'
            ],
            stat: ['17 million', 'Cambodians gained', 'a legal identity.'],
            systems: [
              'Supported registrars and clinics to',
              'record births and deaths as a',
              'routine part of everyday',
              'service delivery.'
            ],
            ysp: [-103.5, -90.5, -77.5, -64.5],
            yst: [-32.0, 0.0, 32.0],
            ysy: [76.5, 89.5, 102.5, 115.5],
            ylp: -116.0,
            yly: 64.0
          },
          sats: {
            policy:
              'Supported national strategies and governance frameworks that embed data use across government systems.',
            comms:
              'Raised awareness of the value of registration and built public demand for it.',
            data: 'Built modern civil registration systems that capture reliable, timely data on births, deaths and causes of death.'
          }
        },
        'overdose-prevention': {
          label: 'Overdose Prevention',
          stat: '5x more likely to carry naloxone.',
          copy: "Drug overdose is the leading cause of death for Black adults under 50 in the U.S. Vital's “You Have the Power to Save Lives” campaign generated 12 million impressions.",
          hub: {
            S: 11,
            STAT: 27,
            LBL: 9,
            H: 213,
            peopleLabel: 'PEOPLE',
            systemsLabel: 'SYSTEMS',
            people: [
              'More people carry naloxone and',
              'know how to recognize and respond',
              'to an overdose.'
            ],
            stat: ['5x more likely to', 'carry naloxone.'],
            systems: [
              'Supported health workers and community',
              'responders to distribute naloxone',
              'and provide harm-reduction',
              'services.'
            ],
            ysp: [-87.0, -72.0, -57.0],
            yst: [-23.5, 8.5],
            ysy: [54.0, 69.0, 84.0, 99.0],
            ylp: -100.5,
            yly: 40.5
          },
          sats: {
            policy:
              'Supported state and local leaders to expand naloxone access and embed harm-reduction strategies into health systems.',
            comms:
              'Amplified trusted voices through an integrated media campaign and community engagement to build public awareness and demand.',
            data: 'Identified racial disparities in overdose mortality and tracked progress across high-burden communities.'
          }
        },
        'vietnam-taxes': {
          label: 'Health Taxes',
          stat: '2.2 million fewer smokers by 2030.',
          copy: "In June 2025, Vietnam's National Assembly raised tobacco and alcohol taxes and passed the country's first-ever tax on sugary drinks — a decade in the making with Vital's support.",
          hub: {
            S: 11,
            STAT: 27,
            LBL: 9,
            H: 213,
            peopleLabel: 'PEOPLE',
            systemsLabel: 'SYSTEMS',
            people: [
              'Fewer people smoke, drink',
              'excessively or consume sugary',
              'drinks as prices rise.'
            ],
            stat: ['2.2 million fewer', 'smokers by 2030.'],
            systems: [
              'Supported tax authorities to implement',
              'and collect the new levies on',
              'tobacco, alcohol and sugary',
              'drinks.'
            ],
            ysp: [-87.0, -72.0, -57.0],
            yst: [-23.5, 8.5],
            ysy: [54.0, 69.0, 84.0, 99.0],
            ylp: -100.5,
            yly: 40.5
          },
          sats: {
            policy:
              "Provided technical policy advice over a decade of partnership with Vietnam's Ministry of Finance and Ministry of Health.",
            comms:
              'Led a multi-year nationwide campaign that built public support and sustained the political will needed for passage.',
            data: 'Modeled the health and economic impact of proposed tax increases and shared the evidence through policy briefs and scientific publications.'
          }
        }
      },
      ORDER: [
        'theory',
        'road-safety',
        'birth-registration',
        'overdose-prevention',
        'vietnam-taxes'
      ],
      REL: {
        'policy-comms': {
          title: 'Policy ↔ Communications',
          a: 'Strategic communications generate public demand, policymaker awareness and momentum for change.',
          b: 'Policy solutions gain the public will and political momentum they need to pass and endure.',
          draft: ['b']
        },
        'comms-data': {
          title: 'Data ↔ Communications',
          a: 'Strategic communications draw upon data to create urgency around problems and proffer credible solutions.',
          b: 'Data rely on strategic communications to ensure that they are well understood across technical and influential non-technical audiences.',
          draft: []
        },
        'data-policy': {
          title: 'Data ↔ Policy',
          a: 'Data are key to crafting policy solutions that are fit for the context and crafted for impact.',
          b: 'Policy solutions are strongest when shaped by data that reveal where risks are greatest and where action will matter most.',
          draft: ['b']
        }
      },
      SATNAME: {
        policy: 'Policy solutions',
        comms: 'Strategic Communications & Advocacy',
        data: 'Data systems & public health intelligence'
      }
    };
    var TABS = COPY.TABS,
      ORDER = COPY.ORDER,
      REL = COPY.REL,
      SATNAME = COPY.SATNAME;
    var ROT = GEO.ROT,
      TT = GEO.TT;

    var tabsEl = root.querySelector('.tabs');
    var ring = root.querySelector('[data-ost-id="ring"]');
    var hubEl = root.querySelector('[data-ost-id="hub-stat"]');
    var hubPL = root.querySelector('[data-ost-id="hub-plabel"]');
    var hubPeo = root.querySelector('[data-ost-id="hub-people"]');
    var hubSL = root.querySelector('[data-ost-id="hub-slabel"]');
    var hubSys = root.querySelector('[data-ost-id="hub-systems"]');
    var eyebrowEl = root.querySelector('[data-ost-id="panel-eyebrow"]');
    var statEl = root.querySelector('[data-ost-id="panel-stat"]');
    var copyEl = root.querySelector('[data-ost-id="panel-copy"]');
    var uprights = [].slice.call(root.querySelectorAll('.upright'));
    var lboxes = [].slice.call(root.querySelectorAll('.lbox'));
    var hits = [].slice.call(root.querySelectorAll('.hit'));
    var ribbons = [].slice.call(root.querySelectorAll('.ribbon'));

    var panelEl = root.querySelector('.panel');
    var REST_LIFT = '-62px'; // tuned below against the Comms box in the rest arrangement
    var ACCENT = {
      policy: 'var(--navy)',
      comms: 'var(--cyan)',
      data: 'var(--policy-blue)',
      'policy-comms': 'var(--ink-soft)',
      'comms-data': 'var(--ink-soft)',
      'data-policy': 'var(--ink-soft)'
    };

    var curTab = 'theory';
    var active = null;
    /* Walk order around the ring: a competency, then the connector to its neighbour, and so on. */
    /* Full walk round the ring: each competency, then the connector to its neighbour.
         After the last connector the button returns to the unselected state. */
    var SEQ = [
      'data',
      'comms-data',
      'comms',
      'policy-comms',
      'policy',
      'data-policy'
    ];

    const SVGNS = 'http://www.w3.org/2000/svg';

    function renderHub() {
      var hub = TABS[curTab].hub;
      function lines(el, arr, ys, size) {
        el.style.fontSize = size + 'px';
        while (el.firstChild) el.removeChild(el.firstChild);
        for (var i = 0; i < arr.length; i++) {
          var ts = document.createElementNS(SVGNS, 'tspan');
          ts.setAttribute('x', GEO.Ox);
          ts.setAttribute('y', GEO.Oy + ys[i]);
          ts.setAttribute('text-anchor', 'middle');
          ts.setAttribute('dominant-baseline', 'central');
          ts.textContent = arr[i];
          el.appendChild(ts);
        }
      }
      lines(hubPeo, hub.people, hub.ysp, hub.S);
      lines(hubEl, hub.stat, hub.yst, hub.STAT);
      lines(hubSys, hub.systems, hub.ysy, hub.S);
      hubPL.textContent = hub.peopleLabel;
      hubPL.setAttribute('y', GEO.Oy + hub.ylp);
      hubSL.textContent = hub.systemsLabel;
      hubSL.setAttribute('y', GEO.Oy + hub.yly);
    }

    function para(txt) {
      var p = document.createElement('p');
      p.className = 'story-copy';
      p.textContent = txt;
      copyEl.appendChild(p);
    }

    function renderPanel() {
      var t = TABS[curTab];
      while (copyEl.firstChild) copyEl.removeChild(copyEl.firstChild);
      statEl.style.display = '';

      if (active && SATNAME[active]) {
        eyebrowEl.textContent = t.label;
        statEl.textContent = SATNAME[active];
        para(t.sats[active]);
      } else if (active && REL[active]) {
        var r = REL[active];
        eyebrowEl.textContent = 'How they connect';
        statEl.textContent = r.title;
        // one side only: keeps the panel under the 205px ceiling, and side "a"
        // is the client-supplied string in all three pairs
        para(r.a);
      } else {
        eyebrowEl.textContent = curTab === 'theory' ? 'Our approach' : 'Impact';
        if (curTab === 'theory') {
          statEl.textContent = t.stat;
        } else {
          statEl.textContent = '';
          statEl.style.display = 'none';
        }
        para(t.copy);
      }
    }

    /* Rotation accumulates instead of snapping to an absolute angle: ROT values are
         modulo 360, so going (say) 90deg -> -210deg would spin the long way round.
         We pick whichever equivalent angle is nearest the current one. */
    var curRot = 0;
    function nearestEquivalent(target, current) {
      var t = target;
      while (t - current > 180) t -= 360;
      while (t - current < -180) t += 360;
      return t;
    }
    function applyRotation(arr) {
      var tt = TT[arr];
      curRot = nearestEquivalent(ROT[arr], curRot);
      var rot = curRot;
      ring.style.transform = 'rotate(' + rot + 'deg)';
      uprights.forEach(function (gg) {
        gg.style.transform = 'rotate(' + -rot + 'deg)';
      });
      lboxes.forEach(function (bx) {
        var d = tt[bx.getAttribute('data-box')];
        bx.style.transform = 'translate(' + d[0] + 'px,' + d[1] + 'px)';
      });
    }
    function markRibbons() {
      ribbons.forEach(function (p) {
        var on = p.getAttribute('data-ribbon') === active;
        p.classList.toggle('dark', on);
        p.setAttribute(
          'marker-end',
          `url(#${on ? root.dataset.tipDarkMarker : root.dataset.tipMarker})`
        );
      });
    }
    function mark() {
      hits.forEach(function (el) {
        var kk = el.getAttribute('data-sat') || el.getAttribute('data-info');
        el.classList.toggle('sel', kk === active);
      });
      lboxes.forEach(function (bx) {
        bx.classList.toggle('sel', bx.getAttribute('data-box') === active);
      });
      markRibbons();
    }
    function advance() {
      var i = SEQ.indexOf(active);
      if (i === SEQ.length - 1) {
        reset();
        return;
      } // past the last step -> nothing selected
      goTo(SEQ[i + 1]); // not on the walk (-1) -> starts at Data
    }
    function reset() {
      active = null;
      applyRotation('rest');
      panelEl.classList.remove('aimed');
      panelEl.style.setProperty('--panel-lift', REST_LIFT);
      mark();
      renderPanel();
    }
    function goTo(key) {
      active = key;
      applyRotation(active);
      panelEl.classList.add('aimed');
      panelEl.style.setProperty('--panel-lift', '0px');
      if (ACCENT[active]) panelEl.style.setProperty('--accent', ACCENT[active]);
      mark();
      renderPanel();
    }
    function select(key) {
      active = active === key ? null : key;
      applyRotation(active || 'rest');
      panelEl.classList.toggle('aimed', !!active);
      panelEl.style.setProperty('--panel-lift', active ? '0px' : REST_LIFT);
      if (active) panelEl.style.setProperty('--accent', ACCENT[active]);
      mark();
      renderPanel();
    }
    hits.forEach(function (el) {
      var kk = el.getAttribute('data-sat') || el.getAttribute('data-info');
      el.addEventListener(EVENTS.CLICK, function () {
        select(kk);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(kk);
        }
      });
    });

    ORDER.forEach(function (key, i) {
      var btn = document.createElement('button');
      btn.className = 'tab';
      btn.type = 'button';
      btn.textContent = TABS[key].label;
      btn.addEventListener(EVENTS.CLICK, function () {
        selectTab(key);
      });
      tabsEl.appendChild(btn);
      if (i === 0) {
        var d = document.createElement('span');
        d.className = 'tab-divider';
        tabsEl.appendChild(d);
      }
    });
    var irisEl = root.querySelector('[data-ost-id="iris"]');
    function hubTexts() {
      return [
        'hub-plabel',
        'hub-people',
        'hub-stat',
        'hub-slabel',
        'hub-systems'
      ].map(function (i) {
        return document.getElementById(i);
      });
    }
    function panelTexts() {
      return [
        root.querySelector('.panel .eyebrow'),
        root.querySelector('.panel .stat'),
        root.querySelector('[data-ost-id="panel-copy"]')
      ];
    }
    function commitTab(key) {
      curTab = key;
      active = null;
      applyRotation('rest');
      panelEl.classList.remove('aimed');
      panelEl.style.setProperty('--panel-lift', REST_LIFT);
      mark();
      renderHub();
      renderPanel();
      var btns = tabsEl.querySelectorAll('.tab');
      ORDER.forEach(function (k, i) {
        btns[i].classList.toggle('active', k === key);
      });
    }
    function selectTab(key, immediate) {
      /* no wipe on first paint, on a repeat click, or while the easter egg owns the iris */
      if (immediate || key === curTab || irisEl.classList.contains('shut')) {
        commitTab(key);
        return;
      }
      var els = hubTexts().concat(panelTexts());
      irisEl.classList.add('wipe', 'fast', 'on', 'peek');
      els.forEach(function (el) {
        if (el) el.classList.add('txt-out');
      });
      setTimeout(function () {
        commitTab(key); /* swap at the narrowest point */
        irisEl.classList.remove('peek');
        hubTexts()
          .concat(panelTexts())
          .forEach(function (el) {
            if (el) el.classList.remove('txt-out');
          });
        setTimeout(function () {
          irisEl.classList.remove('wipe', 'fast', 'on');
        }, 190);
      }, 170);
    }

    root
      .querySelector('[data-ost-id="panel-next"]')
      .addEventListener(EVENTS.CLICK, advance);

    /* ---- easter egg: type "vital" ---- */
    (function () {
      var CODE = 'vital',
        buf = '',
        running = false;
      var iris = root.querySelector('[data-ost-id="iris"]');
      var quote = root.querySelector('[data-ost-id="iris-quote"]');
      var CLOSE = 1100,
        READ = 5600,
        OPEN = 1100,
        SPIN = 1080; // 3 turns

      function reduced() {
        return (
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        );
      }

      document.addEventListener('keydown', function (e) {
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        if (e.target && /^(INPUT|TEXTAREA)$/.test(e.target.tagName)) return;
        var k = (e.key || '').toLowerCase();
        if (k.length !== 1) return;
        buf = (buf + k).slice(-CODE.length);
        if (buf === CODE) {
          buf = '';
          play();
        }
      });

      function play() {
        if (running) return;
        running = true;
        var startRot = getRot();
        var t = [];

        /* let the icons whirl rather than staying upright */
        uprights.forEach(function (g) {
          g.style.transition = 'none';
          g.style.transform = 'none';
        });

        if (reduced()) {
          iris.classList.add('on', 'shut');
          quote.classList.add('on');
          t.push(setTimeout(finish, READ));
        } else {
          spinTo(startRot + SPIN, CLOSE + 300);
          iris.classList.add('on');
          requestAnimationFrame(function () {
            iris.classList.add('shut');
          });
          t.push(
            setTimeout(function () {
              quote.classList.add('on');
            }, CLOSE)
          );
          t.push(
            setTimeout(function () {
              quote.classList.remove('on');
            }, CLOSE + READ)
          );
          t.push(
            setTimeout(function () {
              iris.classList.remove('shut');
              spinTo(startRot, OPEN + 300); /* unwind the other way */
            }, CLOSE + READ + 400)
          );
          t.push(setTimeout(finish, CLOSE + READ + 400 + OPEN + 300));
        }

        function finish() {
          t.forEach(clearTimeout);
          iris.classList.remove('on', 'shut');
          quote.classList.remove('on');
          ring.style.transition = '';
          uprights.forEach(function (g) {
            g.style.transition = '';
          });
          applyRotation(
            active || 'rest'
          ); /* restore upright icons + exact angle */
          running = false;
          document.removeEventListener(EVENTS.CLICK, abort, true);
        }
        function abort() {
          if (running) finish();
        }
        setTimeout(function () {
          document.addEventListener(EVENTS.CLICK, abort, true);
        }, 50);
      }

      function getRot() {
        var m = /rotate\((-?[\d.]+)deg\)/.exec(ring.style.transform || '');
        return m ? parseFloat(m[1]) : 0;
      }
      function spinTo(deg, ms) {
        ring.style.transition =
          'transform ' + ms + 'ms cubic-bezier(.45,0,.25,1)';
        ring.style.transform = 'rotate(' + deg + 'deg)';
      }
    })();

    selectTab('theory', true);
  }
}
